module.exports = __webpack_public_path__ + "static/media/20180523-LCS-045-25.dbfd84e0.jpg";